<template>
  <ToggleSection
    label="Acquisition Details"
    icon-classes="fa-solid fa-microscope"
    :collapsed="false"
  >
    <AssayDescriptionGrid :dv="dv" :fields="fields" />
  </ToggleSection>
</template>

<script>
import { computed } from 'vue'

import { OWNERSHIP_LIFECYCLE_FIELD_NAMES } from '@/constants'

import ToggleSection from '@/components/fields/ToggleSection.vue'

import { CUSTOM_PROPERTIES } from '../../shared/fieldConstants.js'
import AssayDescriptionGrid from './AssayDescriptionGrid.vue'

// Field names explicitly placed in AssayDescription, this component,
// or in the sections rendered below (ownership/lifecycle, sharing).
// slot:fc:run_dir → run_dir, slot:fc:studies → studies
const PLACED_FIELDS = new Set([
  // AssayDescription (widget:instrumentData covers instrument, instrumentmodel, instrumentrun)
  'name',
  'nr_of_samples',
  'id',
  'run_dir',
  'description',
  'protocol_list',
  'instrument',
  'instrumentmodel',
  'instrumentrun',
  // AssayAcquisitionDetailsSection
  'technology',
  'platform',
  'state',
  'is_protected',
  'studies',
  'datasessions',
  // sections rendered below acquisition details
  'permissions',
  'contributors',
  'required_annotations',
  ...OWNERSHIP_LIFECYCLE_FIELD_NAMES,
])

export default {
  name: 'AssayAcquisitionDetailsSection',
  components: {
    ToggleSection,
    AssayDescriptionGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const additionalFields = computed(() =>
      (props.dv.listedFields || [])
        .filter((f) => f.category === 'property' && !PLACED_FIELDS.has(f.name))
        .map((f) => [f.name]),
    )

    const fields = computed(() => [
      ['technology', 'platform'],
      ...additionalFields.value,
      CUSTOM_PROPERTIES,
      ['state', 'is_protected'],
      ['slot:fc:studies'],
      ['datasessions'],
    ])

    return { fields }
  },
}
</script>
